module.exports = __webpack_public_path__ + "static/img/wtf_hover.7ea7cdf.svg";


//////////////////
// WEBPACK FOOTER
// ./static/wtf_hover.svg
// module id = kIfj
// module chunks = 0